import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { environment } from "../../../../Environments/Environment";
import { SearchAuditRequest } from "../Dto/SearchAuditRequest";
import { AuditWithSession, SearchAuditResponse } from "../Dto/AuditModel";

@Injectable({ providedIn: "root" })
export class AuditApi {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.adminServiceUrl;

  async searchAudits(params: SearchAuditRequest): Promise<SearchAuditResponse> {
    const url = new URL("audits", `${this.baseUrl}/`);
    const searchParams = new URLSearchParams();

    if (params.search) {
      searchParams.set("search", params.search);
    }

    if (params.method) {
      searchParams.set("method", params.method);
    }

    if (params.url) {
      searchParams.set("url", params.url);
    }

    if (params.payload) {
      searchParams.set("payload", params.payload);
    }

    if (params.response) {
      searchParams.set("response", params.response);
    }

    if (params.createdAtFrom) {
      searchParams.set("createdAtFrom", params.createdAtFrom);
    }

    if (params.createdAtTo) {
      searchParams.set("createdAtTo", params.createdAtTo);
    }

    if (params.page !== undefined) {
      searchParams.set("page", params.page.toString());
    }

    if (params.limit !== undefined) {
      searchParams.set("limit", params.limit.toString());
    }

    if (searchParams.toString()) {
      url.search = searchParams.toString();
    }

    return await firstValueFrom(this.http.get<SearchAuditResponse>(url.toString(), { withCredentials: true }));
  }

  async getAuditById(id: string): Promise<AuditWithSession> {
    return await firstValueFrom(this.http.get<AuditWithSession>(`${this.baseUrl}/audits/${id}`, { withCredentials: true }));
  }
}
